import React from 'react';
import {Audience} from '@contentlab/api/avatars/types';
import ProjectBasicsForm from '../../shared/ProjectBasicsForm';

const AUDIENCE_OPTIONS = [
  {id: Audience.GenZ, localeLabelKey: 'Gen Z (18-24)'},
  {id: Audience.Millennials, localeLabelKey: 'Millennials (25-40)'},
  {id: Audience.GenX, localeLabelKey: 'Gen X (41-55)'},
  {id: Audience.Students, localeLabelKey: 'Students'},
  {id: Audience.YoungProfessionals, localeLabelKey: 'Young Professionals'},
  {id: Audience.ParentsFamilies, localeLabelKey: 'Parents & Families'},
  {id: Audience.Seniors, localeLabelKey: 'Seniors (55+)'},
];

interface TargetAudienceSectionProps {
  testID?: string;
  selectedAudiences: string[];
  onAudienceSelect: (audience: string) => void;
  label?: string;
}

function TargetAudienceSection({
  testID = 'target-audience-section',
  selectedAudiences,
  onAudienceSelect,
  label = 'Target Audience',
}: TargetAudienceSectionProps) {
  return (
    <ProjectBasicsForm
      testID={testID}
      showTextInput={false}
      chipOptions={AUDIENCE_OPTIONS}
      selectedValues={selectedAudiences}
      onValueSelect={onAudienceSelect}
      chipSectionLabel={label}
      showCustomOption={false}
    />
  );
}

export default TargetAudienceSection;
